//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      current: {
        image: '',
        logo: '',
      },
      newWatermark: {
        image: null,
        logo: null,
      },
    };
  },

  computed: {
    ...mapState('settingsWatermark', ['data']),
  },

  watch: {
    data() {
      const { image, logo } = this.data;
      this.current.image = image;
      this.current.logo = logo;
    },
  },

  methods: {
    ...mapActions('settingsWatermark', [
      'loadData',
      'uploadImage',
      'uploadLogo',
    ]),

    async setWatermarkImage() {
      const formData = new FormData();
      formData.append('Image', this.newWatermark.image);
      await this.uploadImage(formData);
    },

    async setWatermarkLogo() {
      const formData = new FormData();
      formData.append('Logo', this.newWatermark.logo);
      await this.uploadLogo(formData);
    },
  },
};
